// @flow

export default null;



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/Authentication/initialState.js